import styles from './LockedFeatureBadge.module.css';

const LockIcon = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M5.5 6V4.75a2.75 2.75 0 1 1 5.5 0V6h.75A1.25 1.25 0 0 1 13 7.25v6.5A1.25 1.25 0 0 1 11.75 15H4.25A1.25 1.25 0 0 1 3 13.75v-6.5A1.25 1.25 0 0 1 4.25 6H5.5zm1.25-.25V4.75a1.25 1.25 0 1 1 2.5 0V5.75H6.75z"
    />
  </svg>
);

/**
 * Non-interactive plan lock badge. `targetPath` is reserved for future upsell navigation.
 */
export function LockedFeatureBadge({ t, className = '', targetPath = null }) {
  return (
    <span
      className={`${styles.badge} ${className}`.trim()}
      role="status"
      aria-label={t('entitlementsLockedBadge')}
      data-target-path={targetPath || undefined}
    >
      <span className={styles.icon}>
        <LockIcon />
      </span>
      <span>{t('entitlementsLockedBadge')}</span>
    </span>
  );
}
